import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ButtonLink, Container, Eyebrow } from '../components/ui/Primitives';
import { Seo } from '../components/seo/Seo';
import { publishedRoutes } from '../data/seo';
export function NotFound() {
  const {
    pathname
  } = useLocation();
  return <>
      <Seo title="Page Not Found | NexLaw" description="The page you are looking for is not available. Explore NexLaw's legal services, model, and contact options instead." path={pathname} noindex data-id="element-341" data-mp="1557nttyuwcma" />

      <Container className="py-24 md:py-36" data-id="element-342" data-mp="1f1au9c0qqxf1">
        <Eyebrow data-id="element-343" data-mp="1jtc12if53vxo">404</Eyebrow>
        <h1 className="mt-7 max-w-[18ch] font-display text-[38px] font-medium leading-[1.03] tracking-tightest text-ink sm:text-[48px] md:text-[64px]" data-id="element-344" data-mp="1jv565ta3u83k">
          This page could not be found.
        </h1>
        <p className="mt-6 max-w-prose text-[16.5px] leading-relaxed text-graphite" data-id="element-345" data-mp="1sw3euovhn3sh">
          The link may be out of date. Here is where you can go instead.
        </p>

        <nav aria-label="Site pages" className="mt-10 border-t border-line" data-id="element-346" data-mp="1nw3zqnqlmd8n">
          <ul data-id="element-347" data-mp="1ix0ub26pi505">
            {publishedRoutes.map(route => <li key={route.path} className="border-b border-line" data-id="element-348" data-mp="1ivfyzackii18">
                <Link to={route.path} className="block py-4 font-display text-[20px] tracking-tight text-graphite transition-colors hover:text-ink" data-id="element-349" data-mp="1ew78qfgql2af">
                  {route.label}
                </Link>
              </li>)}
          </ul>
        </nav>

        <div className="mt-10" data-id="element-350" data-mp="22l9w83y1xpcu">
          <ButtonLink to="/" data-id="element-351" data-mp="1xu1n790mw607">Back to homepage</ButtonLink>
        </div>
      </Container>
    </>;
}